import { useLanguageData } from '@/common/hooks/useLanguageData';
import { Wrapper, Title, Icon, Text, TopWrapper } from './EndScreen.styles';
import GradientButton from '@/common/components/custom/buttons/GradientButton';
import ConfettiExplosion from 'react-confetti-explosion';

type Props = {
	onFinish: () => void;
};

const EndScreen = ({ onFinish }: Props) => {
	const langData = useLanguageData('features.sceneV3');

	return (
		<Wrapper>
			<ConfettiExplosion zIndex={3} />
			<TopWrapper>
				<Title>{langData.congratulations}</Title>
				<Icon>🎉</Icon>
				<Text>{langData.yourAnswersWereClearAndLucid}</Text>
			</TopWrapper>

			<GradientButton
				title={langData.finish}
				onClick={onFinish}
				style={{ width: 250, aspectRatio: '5.5/1' }}
			/>
		</Wrapper>
	);
};

export default EndScreen;
